export const shipToDetailsURL = `${process.env.REACT_APP_API_ENDPOINT}/order-management/control-tower/`;

export const STATUS_LIST = [
  "PLAN",
  "FORECAST",
  "CONFIRM",
  "PICKUP_READY",
  "DEPARTED",
  "DELIVERED",
  "ARCHIVE",
];

export const DOCUMENT_TYPES = [
  { value: 'TRANSPORT_PERMIT', label: 'Transport Permit', disabled: true },
  { value: 'SHIPPING_ORDER', label: 'Shipping Order', disabled: true },
  { value: 'DATE_ADJUSTMENT', label: 'Date Adjustment Documentation', disabled: false },
  { value: 'COMMUNICATION_INTERNAL', label: 'Communication Internal', disabled: true },
  { value: 'COMMUNICATION_EXTERNAL', label: 'Communication External', disabled: true },
  { value: 'CMR', label: 'CMR', disabled: true },
  { value: 'OTHER', label: 'Other', disabled: true }
];
